// extracted by css-extract-rspack-plugin
export default {"stateSegment":"stateSegment-34RFZ","verticalMenu":"verticalMenu-1FmwE","arrowItem":"arrowItem-235S1","next":"next-2IOw2","prev":"prev-3sn1i","jobinfoPane":"jobinfoPane-4mx3a"};